module.exports = __webpack_public_path__ + "static/will-you-buy-christmas-tree-639132303f7813c447edad7f18e6e553.png";